import { useTheme } from '@mui/material/styles';
import { getColors, typography } from '../tokens';
import { PageBreadcrumbs } from './PageBreadcrumbs';
import type { BreadcrumbSegment } from './PageBreadcrumbs';
import ErrorIcon from '@mui/icons-material/Error';

export type { BreadcrumbSegment };

export type TilePlaceholderProps = {
  name: string;
  title?: string;
  description?: string;
  breadcrumbSegments?: BreadcrumbSegment[];
};

export const TilePlaceholder = ({
  name,
  title = 'Learning Paths — Coming Soon',
  description = 'Curated learning tracks for specific roles and goals are on their way.\nCheck back soon.',
  breadcrumbSegments,
}: Readonly<TilePlaceholderProps>) => {
  const theme = useTheme();
  const colors = getColors(theme.palette.mode);

  const segments = breadcrumbSegments ?? [{ label: name }];

  return (
    <div
      style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        padding: '24px 24px 0',
      }}
    >
      <PageBreadcrumbs segments={segments} />
      <div
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 12,
          paddingBottom: 80,
        }}
      >
        <ErrorIcon
          sx={{
            color: colors.text.primary,
            opacity: 0.6,
            width: 48,
            height: 48,
          }}
        />
        <p
          style={{
            fontFamily: typography.fontFamilyCorpoATextCondensed,
            fontSize: 28,
            fontWeight: 400,
            margin: 0,
            opacity: 0.6,
            color: colors.text.primary,
          }}
        >
          {title}
        </p>
        <p
          style={{
            fontFamily: typography.fontFamilyCorpoSText,
            fontSize: '0.9rem',
            opacity: 0.45,
            margin: 0,
            maxWidth: 420,
            textAlign: 'center',
            color: colors.text.primary,
          }}
        >
          {description}
        </p>
      </div>
    </div>
  );
};
